
import DisplayRealizedGlSwitch from './DisplayRealizedGlSwitch';

export default DisplayRealizedGlSwitch;
